import { useCallback } from 'react';

import {
  trackButtonClick as trackButtonClickUtil,
  trackEvent as trackEventUtil,
} from '@/utils/analytics/trackEvent';
import type { TrackingEvent } from '@/utils/analytics/trackEvent';

/**
 * Hook for using analytics functions in React components
 */
export function useAnalytics() {
  const trackEvent = useCallback((event: TrackingEvent) => {
    trackEventUtil(event);
  }, []);

  const trackButtonClick = useCallback(
    (buttonName: string, properties?: Record<string, unknown>) => {
      trackButtonClickUtil(buttonName, properties);
    },
    [],
  );

  return {
    trackEvent,
    trackButtonClick,
  };
}
